module.exports = __webpack_public_path__ + "img/dsc-5286.4be5311f.jpg";